import { ErrorContext } from '@portals/shared-frontend/hooks';
import { ApiError } from '@portals/shared-frontend/utils/ApiError';
import { ReactNode, useContext } from 'react';
import { Fetcher, SWRConfig } from 'swr';

import { request } from '@/request';

const fetcher: Fetcher = async (url: string) => request(url, 'get');

export function SWRConfigProvider({ children }: { children: ReactNode }) {
  const { setGlobalError } = useContext(ErrorContext);

  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        onError: (error) => setGlobalError(ApiError.isApiError(error) ? error.status : 'unknown'),
        onErrorRetry: (error: ApiError) => {
          // Don't retry on 404 responses
          if (error.status === 404) return;
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
